import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const fetchEnums = createAsyncThunk(
  'enums/fetchEnums',
  async () => {
    try {
      const response = await fetch('http://localhost:5212/api/Enum');
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to fetch enums: ${errorText}`);
      }
      const data = await response.json();
      
      // Transform the enum data into the format we need
      const transformedData = Object.entries(data).reduce((acc, [key, values]) => {
        acc[key.toLowerCase()] = Object.entries(values).map(([name, value]) => ({
          value: value.toString(), // Convert numeric value to string but keep using the numeric value
          label: name.split(/(?=[A-Z])/).join(' ') // Convert camelCase to spaces
        })).sort((a, b) => a.label.localeCompare(b.label)); // Sort while transforming
        return acc;
      }, {});

      return transformedData;
    } catch (error) {
      console.error('Error fetching enums:', error);
      throw error;
    }
  }
);

const enumSlice = createSlice({
  name: 'enums',
  initialState: {
    enums: null,
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEnums.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEnums.fulfilled, (state, action) => {
        state.loading = false;
        state.enums = action.payload;
      })
      .addCase(fetchEnums.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  }
});

export default enumSlice.reducer;
